module.exports = __webpack_public_path__ + "img/ads-markup.be2edc8f.svg";